import { render, staticRenderFns } from "./AccountLayout.vue?vue&type=template&id=4d9282e4&scoped=true"
import script from "./AccountLayout.vue?vue&type=script&lang=js"
export * from "./AccountLayout.vue?vue&type=script&lang=js"
import style0 from "./AccountLayout.vue?vue&type=style&index=0&id=4d9282e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9282e4",
  null
  
)

export default component.exports